import React, { useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import SideBar from "./components/SideBar";
import LoadJquery from "./helper/LoadJquery";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { initTracker } from './api/tracker';
import { isPrefillEnabled } from './utils/devPrefill';

/**
 * The marketing site's header, nav and footer wrap every public page — but the
 * admin console is a different product with its own chrome, so it opts out.
 */
function SiteChrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  if (isAdmin) return children;

  return (
    <>
      <LoadJquery />
      <Header />
      <Navbar />
      <SideBar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // Capture the landing referrer and campaign tags before any navigation
  // rewrites the URL, otherwise every lead is attributed to "direct".
  React.useEffect(() => {
    initTracker();
  }, []);

  React.useEffect(() => {
    let x = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => {
      clearTimeout(x);
    };
  }, [isLoading]);

  return (
    <>
      {/* The NODE_ENV comparison is first on purpose. Webpack substitutes a
          literal "production" there, so the whole block is dead code the
          minifier deletes — the markup never reaches the shipped bundle at
          all, rather than merely not rendering. */}
      {process.env.NODE_ENV === 'development' && isPrefillEnabled() && (
        <div
          style={{
            position: 'fixed', bottom: 12, left: 12, zIndex: 99999,
            padding: '6px 12px', borderRadius: 6,
            background: '#1a1d2e', color: '#fff',
            font: '600 12px/1 Inter, system-ui, sans-serif',
            letterSpacing: '0.04em', boxShadow: '0 4px 14px rgba(0,0,0,.28)',
            pointerEvents: 'none',
          }}
        >
          INTERNSHIP FORM PRE-FILLED &mdash; DEV
        </div>
      )}

      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer position='top-center' />
        <SiteChrome>
          <AppRoutes />
        </SiteChrome>
      </BrowserRouter>

      {/* ==================== Start Loading ==================== */}

      {isLoading ? (
        <div className="loader-wrap">
          <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
            <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
          </svg>

          <div className="loader-wrap-heading">
            <div className="load-text">
              <span>L</span>
              <span>o</span>
              <span>a</span>
              <span>d</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
            </div>
          </div>
        </div>
      ) : null}

      {/* ==================== End Loading ==================== */}
    </>
  );
}

export default App;
